import { useSupabaseLoader } from "../../../server/supabase/hooks";
import type { UseSupabaseLoaderState } from "../../../server/supabase/hooks/types";
import {
  type ConnectionCategoryBase,
  SupabaseConnectionKeysService,
} from "../../merge-tag/server/supabase-connections-key-service";

export type ConnectionCategory = ConnectionCategoryBase & {
  display_name_plural: string;
};
type ConnectionCategoryByKey = {
  [key: string]: ConnectionCategory;
};
export function useConnections(): UseSupabaseLoaderState<{
  list: ConnectionCategory[];
  byKey: ConnectionCategoryByKey;
}> & {
  reload: () => void;
} {
  return useSupabaseLoader<{
    list: ConnectionCategory[];
    byKey: ConnectionCategoryByKey;
  }>(async ({ supabase }) => {
    const service = new SupabaseConnectionKeysService(supabase);
    const categoryBases = await service.getCategories();
    // Make the 'manager' key the first category, then sort the rest alphabetically by key
    categoryBases.sort((a, b) =>
      a.key === "manager" ? -1 : b.key === "manager" ? 1 : a.key.localeCompare(b.key),
    );
    const list = categoryBases.map(({ key, display_name }) => ({
      key,
      display_name,
      // TODO add some pluralisation logic here
      display_name_plural: display_name + "s",
    }));
    const byKey = list.reduce((agg, next) => {
      agg[next.key] = next;
      return agg;
    }, {} as ConnectionCategoryByKey);

    return { list, byKey };
  }, []);
}
